import { appendJobsSectionFilterQueryParameters } from '../../utils/jobs-search-query.utils';

const initializedSections = new WeakSet();

const getAsyncVacancySections = (scope = document) => {
    const root = scope instanceof Element ? scope : document;

    if (root.matches?.('[data-vacancies-async]')) {
        return [root];
    }

    return Array.from(root.querySelectorAll('[data-vacancies-async]'));
};

const getFilters = (section) => {
    const filters = {};
    const jobType = section.dataset.vacanciesJobType;

    if (jobType) {
        filters.job_type = [jobType];
    }

    section.querySelectorAll('[data-filter-param]').forEach((group) => {
        const param = group.dataset.filterParam;
        const activeButton = group.querySelector('.filters-slider__btn.is-active');
        const value = activeButton?.dataset.filter;

        if (param && value && value !== 'all') {
            filters[param] = [value];
        }
    });

    return filters;
};

const updateViewAllUrl = (section, filters) => {
    const jobsUrl = section.dataset.vacanciesJobsUrl;
    const viewAllLinks = section.querySelectorAll('[data-vacancies-view-all]');

    if (!jobsUrl || !viewAllLinks.length) {
        return;
    }

    viewAllLinks.forEach((viewAllLink) => {
        const url = new URL(jobsUrl, window.location.origin);

        if (viewAllLink.hasAttribute('data-vacancies-view-all-unfiltered')) {
            url.search = '';
        } else {
            appendJobsSectionFilterQueryParameters(url, filters);
        }

        viewAllLink.href = url.toString();
    });
};

const refreshCardEnhancements = (slides) => {
    if (typeof window.initBtnRoll === 'function') {
        window.initBtnRoll(slides);
    }

    if (typeof window.initDataTilt === 'function') {
        window.initDataTilt(slides).catch(() => {});
    }

    if (slides.querySelector('[data-aos]') && typeof window.refreshAos === 'function') {
        window.refreshAos();
    }
};

const initHomeVacancyFilters = (scope = document) => {
    getAsyncVacancySections(scope).forEach((section) => {
        if (initializedSections.has(section)) {
            return;
        }

        const slides = section.querySelector('[data-vacancies-slides]');
        const slider = section.querySelector('.vacancies-swiper-wr');
        const emptyMessage = section.querySelector('[data-vacancies-empty]');
        const url = section.dataset.vacanciesUrl;
        const context = section.dataset.vacanciesContext;

        if (!slides || !slider || !url || !context) {
            return;
        }

        initializedSections.add(section);

        let controller = null;

        const requestVacancies = async () => {
            controller?.abort();
            const requestController = new AbortController();
            controller = requestController;

            const filters = getFilters(section);
            const payload = new FormData();
            payload.append('context', context);

            Object.entries(filters).forEach(([name, values]) => {
                values.forEach((value) => payload.append(`${name}[]`, value));
            });

            updateViewAllUrl(section, filters);
            section.setAttribute('aria-busy', 'true');

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
                    },
                    body: payload,
                    signal: requestController.signal,
                });

                if (!response.ok) {
                    throw new Error('Unable to load vacancies.');
                }

                const result = await response.json();

                if (requestController.signal.aborted || controller !== requestController) {
                    return;
                }

                if (typeof window.destroyVacanciesSwiper === 'function') {
                    window.destroyVacanciesSwiper(slider);
                }

                slides.innerHTML = result.html || '';

                if (emptyMessage) {
                    emptyMessage.hidden = Number(result.count) > 0;
                }

                if (typeof window.refreshVacanciesSwiper === 'function') {
                    window.refreshVacanciesSwiper(slider);
                }

                refreshCardEnhancements(slides);
            } catch (error) {
                if (error.name !== 'AbortError' && typeof window.noticeError === 'function') {
                    window.noticeError('Unable to load vacancies. Please try again.');
                }
            } finally {
                if (controller === requestController) {
                    section.setAttribute('aria-busy', 'false');
                }
            }
        };

        section.addEventListener('click', (event) => {
            const button = event.target.closest('[data-filter-param] .filters-slider__btn');

            if (!button || !section.contains(button)) {
                return;
            }

            window.requestAnimationFrame(requestVacancies);
        });

        updateViewAllUrl(section, getFilters(section));
    });
};

initHomeVacancyFilters();
window.initHomeVacancyFilters = initHomeVacancyFilters;
